<template>
  <div class="tablePage-all-box">
    <el-table
      ref="tableContent"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{
        background: 'rgba(245,246,250,1)',
        lineHeight: '23px',
        color: '#232323'
      }"
      @selection-change="selectionChange"
    >
      <el-table-column :selectable="selectable" type="selection" width="55" />
      <slot name="tableItem" />
    </el-table>

    <pagination-page
      v-if="showPagination"
      ref="tablePage"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      :change-fun="changeTablePage"
    />
  </div>
</template>

<script>
export default {
  name: 'TablePage',
  components: {},
  props: {
    // 表格数据
    tableData: {
      type: Array
    },
    // 数据总条数
    total: {
      type: Number,
      default: 10
    },
    // 显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 页码改变调用 function(currentPage, pageSize)
    changeFun: {
      type: Function
    },
    currentPage: {
      type: Number,
      default: 1
    },
    selectable:{
      type:Function,
      default:()=>{return true}
    }
  },
  data() {
    return {
      multipleSelection: [], // tab 多选数据数组
      pageSize: 10
    }
  },
  mounted() {
    const self = this
    window.tablePage = self
  },
  methods: {
    /**
    * table 选中事件
    * @param val
    */
    selectionChange(val) {
      this.multipleSelection = val
      this.$emit('selectionChange', val)
      console.log(this.multipleSelection)
    },

    /**
     * tab 分页的 change 方法
     */
    changeTablePage(currentPage, pageSize) {
      this.changeFun(currentPage, pageSize)
      console.log('tablePage change 方法', currentPage, pageSize)
    }
  }
}
</script>

<style lang="scss">
    .tablePage-all-box {

    }
</style>
